"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=95%3A392))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:36:41.022Z
 * @optimized using svgo:^3.0.2
 */
export const Lightbulb = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.975 11.781q.178.315.374.646c.438.745.91 1.547 1.184 2.398l1.082 3.08h6.77l1.081-3.08c.274-.85.746-1.652 1.184-2.397l.002-.003q.195-.33.373-.644c.539-.961.946-1.888.946-2.97 0-4.281-3.14-7.717-6.971-7.717S5.03 4.53 5.03 8.811c0 1.082.406 2.009.945 2.97M17.44 15.18c.23-.712.633-1.407 1.084-2.173l.003-.007c.128-.216.259-.44.382-.659.562-1.003 1.09-2.143 1.09-3.53C20 3.964 16.437 0 12 0 7.565 0 4 3.964 4 8.811c0 1.387.529 2.527 1.091 3.53.124.221.255.445.383.662l.002.004c.45.766.854 1.461 1.084 2.173l.01.028 1.08 3.08c.15.428.535.712.965.712h6.77c.43 0 .814-.284.965-.712l1.08-3.08.006-.015zM8 21.5c0-.276.216-.5.483-.5h7.033c.267 0 .484.224.484.5s-.217.5-.484.5H8.483A.49.49 0 0 1 8 21.5m0 2c0-.276.216-.5.483-.5h7.033c.267 0 .484.224.484.5s-.217.5-.484.5H8.483A.49.49 0 0 1 8 23.5"
    fill="currentColor"
  />,
  "Lightbulb",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
